import config from '../../config';

export default {
  url: `${config.api.baseURL}/forgot-pin`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/pin/forgot.js